// src/components/Benefits.js
import React from 'react';

const benefits = [
  {
    title: 'Increase leads and sales',
    text: 'Attract ready-to-buy customers with targeted campaigns, conversion-optimized landing pages, and performance tracking.',
  },
  {
    title: 'High-converting websites',
    text: 'Get modern, responsive websites that load fast, look premium, and are built to turn visitors into enquiries.',
  },
  {
    title: 'ROI-driven marketing',
    text: 'Every ad rupee is tracked and optimized – from creatives to copy to audiences – so you see real business results.',
  },
  {
    title: 'Creative branding that stands out',
    text: 'Brand identity, graphics, and videos that make your business memorable across social media and the web.',
  },
];

const Benefits = () => {
  return (
    <section className="section" aria-labelledby="benefits-heading">
      <div className="section-inner">
        <div className="section-header">
          <h2 id="benefits-heading">Why businesses choose HFA Digital Creations?</h2>
          <p>
            Work with a partner that understands design, technology, and marketing – and combines
            all three to grow your business online.
          </p>
        </div>
        <div className="grid-2 benefits-grid grid">
          {benefits.map((b) => (
            <article
              key={b.title}
              className="benefit-card glass-card reveal-on-scroll"
            >
              <div className="benefit-icon glow-icon" aria-hidden="true">
                ⚡
              </div>
              <h3>{b.title}</h3>
              <p>{b.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
